import { Input } from '@/common/ui/input'
import { cn } from '@/common/lib/utils'
import { Button } from '../button'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { useEffect } from 'react'
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '@/common/ui/tooltip'
import { InfoIcon } from 'lucide-react'

interface DataTableSearchProps {
	placeHolder: string
	searchHint?: string
}

export function DataTableSearch({
	placeHolder,
	searchHint,
}: DataTableSearchProps) {
	const {
		searchQuery,
		setSearchQuery,
		setCurrentPage,
		setLocalSearch,
		localSearch,
	} = useTablePagination()

	const handleSearchChange = (value: string) => {
		setLocalSearch(value)
	}

	const handleFetch = () => {
		setSearchQuery(localSearch)
		setCurrentPage(1)
	}

	useEffect(() => {
		setLocalSearch(searchQuery)
	}, [searchQuery])

	return (
		<div className="flex flex-row items-center gap-2">
			<div className="relative flex flex-1 items-center gap-2">
				<Input
					placeholder={`${placeHolder}`}
					value={localSearch ?? ''}
					onChange={(e) => handleSearchChange(e.target.value)}
					className={cn('h-8 w-full min-w-0 text-sm sm:h-9 sm:text-base')}
					onKeyDown={(e) => {
						if (e.key === 'Enter') {
							handleFetch()
						}
					}}
				/>
				{searchHint && (
					<TooltipProvider>
						<Tooltip>
							<TooltipTrigger asChild>
								<button
									type="button"
									className="inline-flex items-center"
									onClick={(e) => e.preventDefault()}
								>
									<InfoIcon className="h-4 w-4 cursor-help text-muted-foreground transition-colors hover:text-foreground" />
								</button>
							</TooltipTrigger>
							<TooltipContent className="max-w-xs">
								<p className="text-xs">{searchHint}</p>
							</TooltipContent>
						</Tooltip>
					</TooltipProvider>
				)}
			</div>
			<Button
				onClick={handleFetch}
				size="sm"
				className="h-8 shrink-0 px-3 text-xs sm:h-9 sm:px-4 sm:text-sm"
			>
				ค้นหา
			</Button>
		</div>
	)
}
